module.exports = __webpack_public_path__ + "static/media/driverwallet.336d7f67.png";